// src/components/Footer.jsx
import React from "react";
import "../styles/Footer.scss";

const Footer = () => {
  return (
    <footer className="footerSection">
      <div className="footerWrap">
        {/* Marca */}
        <div className="footerBrand">
          <h3 className="footerLogo">Pixbae Banquetes</h3>
          <p className="footerDesc">
            Experiencias gastronómicas al carbón para eventos residenciales y
            empresariales en Guadalajara, Zapopan y Tlajomulco de Zúñiga.
          </p>
        </div>

        {/* Redes */}
        <div className="footerSocial">
          <span className="socialTitle">Síguenos</span>
          <div className="socialLinks">
            <a
              href="https://www.facebook.com/pixbaebanquetes/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook Pixbae Banquetes"
            >
              <ion-icon name="logo-facebook"></ion-icon>
            </a>

            <a
              href="https://www.instagram.com/pixbaebanquetes/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram Pixbae Banquetes"
            >
              <ion-icon name="logo-instagram"></ion-icon>
            </a>
          </div>
        </div>
      </div>

      {/* Línea inferior */}
      <div className="footerBottom">
        <span>
          © {new Date().getFullYear()} Pixbae Banquetes. Todos los derechos
          reservados.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
